import { render, staticRenderFns } from "./unperturbed.vue?vue&type=template&id=38097534&scoped=true"
import script from "./unperturbed.vue?vue&type=script&lang=js"
export * from "./unperturbed.vue?vue&type=script&lang=js"
import style0 from "./unperturbed.vue?vue&type=style&index=0&id=38097534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38097534",
  null
  
)

export default component.exports